import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ShoppingProducts } from '@app/apps/shoppingCart/interfaces/ShoppingProductsItem';
import { ShoppingCartConfiguration } from '@app/apps/shoppingCart/interfaces/configuration';
import {
  ShoppingCartQueue,
  SubmittedShoppingCart,
} from '@app/apps/shoppingCart/interfaces/shoppingCartQueue';
import { ShoppingCartService } from '@app/apps/shoppingCart/shoppingCart.service';
import * as g from '@app/globals';
import { LayoutService } from '@app/layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { switchMap, tap } from 'rxjs/operators';
@Component({
  selector: 'app-cart-products-widget',
  templateUrl: './cart-products-widget.component.html',
  styleUrls: ['./cart-products-widget.component.less'],
  providers: [ShoppingCartService],
})
export class CartProductsWidgetComponent implements OnInit, AfterViewInit {
  @Input() products: ShoppingProducts[] = [];
  shoppingCartId = 0;
  shoppingCartConfigs: ShoppingCartConfiguration;
  totals: { price: number; quantity: number } = {
    price: 0,
    quantity: 0,
  };
  scrollableElement?: HTMLElement = null;
  itemsPerView = 3;
  scrollAmount = 0;
  constructor(
    private shoppingCartService: ShoppingCartService,
    private messageService: NzMessageService,
    private layoutService: LayoutService
  ) {}
  ngAfterViewInit(): void {
    let counter = 0;
    const tempInterval = setInterval(() => {
      this.scrollableElement = document.getElementById(
        'shoppingCartsProductsCardsContainer'
      );
      counter++;
      if (counter === 6 || this.scrollableElement != null) {
        clearInterval(tempInterval);
      }
    }, 500);

    setTimeout(() => {
      this._getProductCards();
    }, 1500);
  }

  ngOnInit() {
    this._getShoppingCart();
  }

  onProductQuantityChanged(params: {
    item: ShoppingProducts;
    newQuantity: number;
  }) {
    const sp: SubmittedShoppingCart = {
      CardCode: g.userIdentity.CardCode,
      CntctCode: g.userIdentity.ContactCode,
      DocEntry: this.shoppingCartId.toString(),
      QueueToUpdate: [
        {
          ItemCode: params.item.ItemCode,
          SelectedQuantity: params.newQuantity,
          ManualWhs: false,
        },
      ],
    };
    this.shoppingCartService.queueToUpdate('1', sp, undefined).subscribe(() => {
      this.messageService.success(
        this.layoutService.translate('Items added to the shopping cart.')
      );
      this._getShoppingCart();
    });
  }
  private _getShoppingCart() {
    this.shoppingCartService
      .getListOfShoppingCarts(g.userIdentity.CardCode, '1')
      .pipe(
        tap((response: any) => {
          const results = response.Resault_Value.rowsArray as any[];
          if (results.length === 0) {
            return;
          }
          this.shoppingCartId = results[0].U_DocEntry;
        }),
        switchMap(() =>
          this.shoppingCartService.getShoppingCartInfo(
            '1',
            this.shoppingCartId.toString()
          )
        ),
        tap((cartInfo) => {
          const cartLines = cartInfo?.Resault_Value?.Lines;
          if (cartLines == null || cartLines?.length === 0) {
            return;
          }
          this.products.forEach((prod) => {
            const cartLine = cartLines.find(
              (x) => x.ItemCode === prod.ItemCode
            );
            if (cartLine != null) {
              prod.SelectedQuantity = cartLine.Quantity;
              prod.LineTotal = cartLine.LineTotal;
              prod.WarehouseCode = cartLine.WarehouseCode;
              this.totals.quantity += prod.SelectedQuantity;
              this.totals.price += cartLine.LineTotal;
            }
          });
          this.products = [...this.products];
        }),
        switchMap(() => this.shoppingCartService.ShoppingCartConfiguration()),
        tap((configs) => {
          this.shoppingCartConfigs = configs;
        })
      )
      .subscribe();
  }

  private _getProductCards() {
    const elements = document.getElementsByClassName('cart-product-card');
    if (elements.length === 0) {
      setTimeout(() => {
        if (elements.length) {
          this._getProductCardWidth(elements[0]);
        }
      }, 1000);
    } else {
      this._getProductCardWidth(elements[0]);
    }
  }
  private _getProductCardWidth(element: Element) {
    const width = element.clientWidth;
    this.scrollAmount = width * this.itemsPerView;
  }
  scrollLeft() {
    this.scrollableElement.scrollLeft -= this.scrollAmount;
  }
  scrollRight() {
    this.scrollableElement.scrollLeft += this.scrollAmount;
  }
}
